module.exports = __webpack_public_path__ + "img/craft_card.27dc64d5.jpg";